import axios from 'axios'
import Vue from 'vue'
export default {
  namespaced: true,
  state: () => ({
    interviews: {}
  }),
  getters: {
    interviews: state => Object.values(state.interviews),
    byId: state => id => state.interviews[id]
  },
  mutations: {
    set(state, {
      id,
      patient_id,
      patient_age_in_months,
      patient_gender,
      type,
      language,
      status,
      checkup_id,
      checkup_device,
      schedule_id,
      triage,
      current_question,
      evidences,
      conditions,
      recommended_labtests,
      obligatory_labtests,
      created_at,
      created_by,
      finished_at
    }) {
      if (!state.interviews[id]) {
        Vue.set(state.interviews, id, {})
      }
      Vue.set(state.interviews[id], 'id', id)
      Vue.set(state.interviews[id], 'patient_id', patient_id)
      Vue.set(state.interviews[id], 'patient_age_in_months', patient_age_in_months)
      Vue.set(state.interviews[id], 'patient_gender', patient_gender)
      Vue.set(state.interviews[id], 'type', type)
      Vue.set(state.interviews[id], 'language', language)
      Vue.set(state.interviews[id], 'status', status)
      Vue.set(state.interviews[id], 'checkup_id', checkup_id)
      Vue.set(state.interviews[id], 'checkup_device', checkup_device)
      Vue.set(state.interviews[id], 'schedule_id', schedule_id)
      Vue.set(state.interviews[id], 'current_question', current_question)
      Vue.set(state.interviews[id], 'evidences', evidences)
      Vue.set(state.interviews[id], 'conditions', conditions)
      Vue.set(state.interviews[id], 'triage', triage)
      Vue.set(state.interviews[id], 'recommended_labtests', recommended_labtests)
      Vue.set(state.interviews[id], 'obligatory_labtests', obligatory_labtests)
      Vue.set(state.interviews[id], 'created_at', created_at)
      Vue.set(state.interviews[id], 'created_by', created_by)
      Vue.set(state.interviews[id], 'finished_at', finished_at)
    },
    reset(state) {
      Vue.set(state, 'interviews', {})
    }
  },
  actions: {
    async init({ commit, rootGetters }, { type, age, gender, locale }) {
      // console.log(rootGetters['auth/user'])
      const authUser = rootGetters['auth/user']
      let url = '/guest/interviews'
      if (authUser) {
        url = '/api/interviews'
      }
      try {
        const params = {
          type: type,
          language: locale
        }
        if (age) {
          params.age = parseInt(age)
        }
        if (gender) {
          params.gender = gender
        }
        if (authUser) {
          params.patient_id = authUser.id
        }
        const response = await axios.post(url, params)
        return response.data.data.id
      } catch (err) {
        commit('alert/setError', err, { root: true })
      }
    }
  }
}
